/**
 * Membership core shared by the metric compatibility entry points: whether a metric's resolved
 * supported units (see `resolveMetricUnits`) include the given randomization unit. Comparison is on
 * the exact key. Unresolved units (`undefined`) are not a positive match; callers layer their own
 * policy on top of that case.
 */
export function metricUnitsIncludeUnit(resolvedUnits: readonly string[] | undefined, unit: string): boolean {
  return resolvedUnits !== undefined && resolvedUnits.includes(unit);
}
